import { render, staticRenderFns } from "./UpdateApp.vue?vue&type=template&id=1e5709f6&scoped=true&"
import script from "./UpdateApp.vue?vue&type=script&lang=js&"
export * from "./UpdateApp.vue?vue&type=script&lang=js&"
import style0 from "./UpdateApp.vue?vue&type=style&index=0&id=1e5709f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5709f6",
  null
  
)

export default component.exports